import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { MessageService } from '../../../core/service/message.service';
import { BuildingSpaceService } from '../../service/data/building-space.service';
import { BuildingSpace } from '../../model/building-space';
import { Building } from '../../model/building';
import { Subscription } from 'rxjs/internal/Subscription';
import { BuildingSpaceTypeService } from '../../service/data/building-space-type.service';
import { SelectionItem } from '../../../core/component/select/select.component';
import { BuildingSpaceType } from '../../model/building-space-type';
import { BuildingService } from '../../service/data/building.service';
import { PropertyService } from '../../service/data/property.service';
import { catchError, finalize } from 'rxjs/operators';

@Component({
    selector: 'app-move-building-to-property-dialog',
    templateUrl: './move-building-to-property-dialog.component.html',
    styleUrls: ['./move-building-to-property-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MoveBuildingToPropertyDialogComponent implements OnInit, OnDestroy {
  constructor(
    private _dialogService: ActionWindowService,
    private _dataService: BuildingService,
    private _messageService: MessageService,
    propertyService: PropertyService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory
  ) {
    this.propertyService = propertyService;
  }

  ngOnDestroy(): void {
    if (this.loadSub) this.loadSub.unsubscribe();
    if (this.sub) this.sub.unsubscribe();
  }

  @Input() dataContext: Building;

  propertyService: PropertyService;
  form: FormGroup;

  cancel() {
    this._dialogService.close();
  }
  private loadSub: Subscription;
  private sub: Subscription = new Subscription();

  ngOnInit() {
    this.form = this._fb.group({
      buildingId: this._fcf.createHidden(this.dataContext.id),
      destinationPropertyId: this._fcf.createMandatory('COMMON.PROPERTY', null),
    });
  }

  private _working = false;
  onSubmit() {
    if (this._working) return;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this._working = true;
    var formData = this.form.value;
    this._dataService
      .moveToProperty(formData.buildingId, formData.destinationPropertyId)
      .pipe(
        finalize(() => {
          this._working = false;
        }),
        catchError(err => {
          this._messageService.showError(err);
          this._dialogService.close();
          throw err;
        })
      )
      .subscribe(res => {
        this._messageService.showSuccess();
        this._dialogService.complete(true);
      });
  }
}
